import React, { useEffect } from "react"
import { useNavigate, useMatch } from "react-router-dom"

import { useAppDispatch } from "redux/hooks"
import { makeEmailConfirmation } from "redux/features/client/emailConfirmationThunk"
import { showAlert, showNotice } from "redux/features/notice/noticeSlice"
import { CLIENT_EMAIL_CONFIRMATION_MATCH, CLIENT_PROFILE_MATCH } from "config"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  onSuccess: () => void
}

const EmailConfirmation = ({ onSuccess }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const emailConfirmationMatch = useMatch(CLIENT_EMAIL_CONFIRMATION_MATCH)

  useEffect(() => {
    if (emailConfirmationMatch) {
      const { params } = emailConfirmationMatch
      const { token } = params

      if (token) {
        dispatch(makeEmailConfirmation({ token }))
          .then((result) => {
            onSuccess()
            dispatch(showNotice({ message: result }))
          })
          .catch((error) => {
            dispatch(showAlert({ message: error }))
          })
          .finally(() => {
            navigate(CLIENT_PROFILE_MATCH)
          })
      }
    }
  }, [location])

  return <></>
}

export default EmailConfirmation
